import React from 'react';
import { WHAT, IMAGES } from '../data/mock';
import Reveal from './Reveal';
import { Flame } from 'lucide-react';

const WhatSection = () => {
  return (
    <section id="what" className="relative py-24 md:py-40 px-6 md:px-10">
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-16 md:gap-20 items-center">
        <Reveal>
          <div className="relative aspect-[4/5] overflow-hidden group">
            <div
              role="img"
              aria-label="Bertie Watkins as the Inquisitor in ASH — one of the most terrifying performances at London's best immersive Halloween theatre show 2026."
              className="absolute inset-0 bg-cover transition-transform duration-[3000ms] group-hover:scale-105"
              style={{
                backgroundImage: `url(${IMAGES.inquisitor})`,
                backgroundPosition: '50% 25%'
              }}
            />
            <div className="absolute inset-0 bg-gradient-to-br from-[#0a0705]/30 via-transparent to-[#0a0705]/85" />
            <div className="absolute bottom-6 left-6 right-6">
              <p className="font-fell italic text-[#d9c8a3] text-sm leading-relaxed">
                &ldquo;{WHAT.italic.replace(/^"|"$/g, '')}&rdquo;
              </p>
              <p className="mt-2 text-[10px] tracking-[0.35em] text-[#8b7355] font-fell-sc">
                — BERTIE WATKINS, THE INQUISITOR
              </p>
            </div>
          </div>
        </Reveal>

        <div>
          <Reveal>
            <h2 className="font-display text-6xl md:text-7xl text-[#e8dcc0] lowercase tracking-tight">
              {WHAT.heading}
            </h2>
          </Reveal>
          <Reveal delay={150}>
            <div className="mt-8 divider-ornament max-w-[220px] mx-0">
              <Flame className="w-3.5 h-3.5 text-[#c8935a]/70" />
            </div>
          </Reveal>

          <Reveal delay={200}>
            <p className="mt-8 font-fell text-lg md:text-xl text-[#d9c8a3] leading-[1.75]">
              {WHAT.body}
            </p>
          </Reveal>

          <Reveal delay={300}>
            <ul className="mt-8 space-y-3">
              {WHAT.bullets.map((b, i) => (
                <li
                  key={i}
                  className="flex items-start gap-3 font-fell-sc text-[12px] tracking-[0.25em] text-[#c8935a]"
                >
                  <span className="mt-1 h-px w-6 bg-[#c8935a]/60" />
                  <span className="uppercase">{b}</span>
                </li>
              ))}
            </ul>
          </Reveal>

          <Reveal delay={400}>
            <div className="mt-10 pt-8 border-t border-[#3a2818]/60 text-[13px] text-[#a89880] font-fell leading-relaxed space-y-3">
              <p>{WHAT.note}</p>
              <p className="italic text-[#8b7355]">{WHAT.refund}</p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default WhatSection;
